import { isValidPrice } from '@domain-group/javascript-utils'

const state = {
  hidden: false,
  id: null,
  is_default: false,
  price: 0,
  product_code: '',
  provider_price_list_item_option_id: '',
  title: '',
}

export const requiredFields = [
  { key: 'price', validation: isValidPrice },
  { key: 'provider_price_list_item_option_id' },
  { key: 'title' },
]

export default state
